import React from "react";

function ContactView() {
  return (
    <div className="contact-main">
      <div className="contact-inner">
        <div className="contact-ey">Contact</div>
        <div className="contact-h">Let's work together.</div>
        <div className="contact-sub">
          I'm currently available for freelance projects and full-time roles. If
          you have something interesting in mind, I'd love to hear about it.
        </div>

        <div className="contact-items">
          <a className="contact-item" href="mailto:bannawit.kh@gmail.com">
            <div className="ci-icon">✉</div>
            <div>
              <div className="ci-label">Email</div>
              <div className="ci-value">bannawit.kh@gmail.com</div>
            </div>
            <div className="ci-arr">→</div>
          </a>
          <a
            className="contact-item"
            href="https://www.linkedin.com/in/bannawit-brann-khattiyanont/"
            target="_blank"
            rel="noreferrer"
          >
            <div className="ci-icon">in</div>
            <div>
              <div className="ci-label">LinkedIn</div>
              <div className="ci-value">
                linkedin.com/in/Bannawit-Brann Khattiyanont
              </div>
            </div>
            <div className="ci-arr">→</div>
          </a>
          <a
            className="contact-item"
            href="https://www.brannkh.com"
            target="_blank"
            rel="noreferrer"
          >
            <div className="ci-icon">🌐</div>
            <div>
              <div className="ci-label">Website</div>
              <div className="ci-value">brannkhatti.com</div>
            </div>
            <div className="ci-arr">→</div>
          </a>
        </div>

        <div className="avail-block">
          <div className="avail-label">Status</div>
          <div className="avail-text">Available from August 12, 2025</div>
          <div className="avail-sub">Michigan-based · Open to remote</div>
        </div>
      </div>
    </div>
  );
}

export default ContactView;
